<template>
  <div class='child-head'>
   
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="白名单" name="first">
        <my-black category=0 v-if="activeName==='first'"></my-black>
      </el-tab-pane>
      <el-tab-pane label="黑名单" name="second">
        <my-black category=1 v-if="activeName==='second'"></my-black>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import black from "./hbmd/black";

export default {
    components: {
    "my-black": black
  },
  data() {
    return {
     activeName: "first",
    };
  },
  methods: {
    handleClick(tab, event){
    }
  }
};
</script>

<style>
.lftj_title
{
width:100%;text-align:center;font-size:x-large;font-weight:bold;margin: 15px auto;
}
.lftj_search
{
  width:100%;text-align:center;
}
</style>


// WEBPACK FOOTER //
// src/views/fksys/hbmd.vue